import { LOGIN, LOGOUT } from '../mutation-types'

const state = {
  authData: {},
}

const mutations = {
  [LOGIN] (state, data) {
    if (data) {
      state.authData = data
    }
  },
  [LOGOUT] (state) {
    state.authData = {}
  }
}

export default {
  state,
  mutations
}
